// Friendly branch when a cheque has no valid linked account (overdraft check can't run).
const fmt = (n) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

export function NoLinkedAccountNotice({ od, ccy, lang }) {
  return (
    <div className="p-4 rounded-2xl neu-inset text-sm leading-relaxed space-y-2">
      <p className="font-bold text-red-700">
        {lang === "ar" ? "هذا الشيك غير مرتبط بأي حساب صالح." : "This cheque isn't linked to any valid account."}
      </p>
      <p className="text-slate-600 text-xs">
        {lang === "ar"
          ? "افتح تعديل الشيك، اختر الحساب البنكي/البطاقة التي سيُخصم منها المبلغ، ثم احفظ. بعدها اضغط \"مدفوع\" وسيتم فحص الرصيد."
          : "Open the cheque, pick the source bank/card, save, then mark as paid. The balance check will then run."}
      </p>
      <div className="flex justify-between tabular-nums pt-2 border-t border-slate-200 mt-2">
        <span className="text-slate-500">{lang === "ar" ? "قيمة الشيك" : "Cheque amount"}</span>
        <span className="font-bold">{fmt(od.adding)} {ccy}</span>
      </div>
    </div>
  );
}
